import React, { useEffect, useRef, useState } from "react";

const CopyToClipBoard = (props: any) => {
  const [items, setItems] = useState<Array<any>>([]);
  const clipboardRef: any = useRef(null);

  useEffect(() => {
    let ls: any = localStorage.getItem("clipboard");
    if (ls) {
      ls = JSON.parse(ls);
      setItems(ls.items);
    }
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        clipboardRef.current &&
        !clipboardRef.current.contains(event.target)
      ) {
        props.openCloseClip();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clipboardRef]);

  const clear = () => {
    props.openCloseClip();
    localStorage.removeItem("clipboard");
    setItems([]);
  };

  return (
    <div
      ref={clipboardRef}
      className="z-50 absolute w-72 h-auto max-h-96 bg-yellow-300 rounded-lg border p-2 overflow-y-auto"
    >
      {items.length > 0 && (
        <div className="flex justify-end mt-5">
          <button
            onClick={() => clear()}
            className="inline-flex items-center px-2 py-1 my-2 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
          >
            Clear
          </button>
        </div>
      )}
      <div className="flex justify-between items-center border-b mb-2">
        <div>Copied Question Id</div>
        <div className="text-lg cursor-pointer" onClick={props.openCloseClip}>
          X
        </div>
      </div>
      <ul>
        {items.map((item, i) => (
          <li key={i}>{item},</li>
        ))}
      </ul>
      {items.length === 0 && <div className="p-3">No records found!</div>}
    </div>
  );
};

export default CopyToClipBoard;
